"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSeerRating = void 0;
const react_1 = require("react");
const queries_1 = require("../graphql/queries");
const amplifyBootstrap_1 = require("../utils/amplifyBootstrap");
function useSeerRating() {
    const [data, setData] = (0, react_1.useState)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [lastHubId, setLastHubId] = (0, react_1.useState)(null);
    const fetchSeerRating = (0, react_1.useCallback)(async (hubId) => {
        setLoading(true);
        setError(null);
        setLastHubId(hubId);
        try {
            const response = await amplifyBootstrap_1.API.graphql({
                query: queries_1.getSeerRating,
                variables: { hubId },
            });
            const seerRatingData = response.data?.getSeerRating;
            if (seerRatingData) {
                setData(seerRatingData);
            }
            else {
                setError('No SEER rating data found for this hub');
            }
        }
        catch (err) {
            console.error('Error fetching SEER rating:', err);
            setError(err instanceof Error ? err.message : 'Failed to fetch SEER rating');
            setData(null);
        }
        finally {
            setLoading(false);
        }
    }, []);
    const refetch = (0, react_1.useCallback)(async () => {
        if (lastHubId) {
            await fetchSeerRating(lastHubId);
        }
    }, [lastHubId, fetchSeerRating]);
    return {
        data,
        loading,
        error,
        fetchSeerRating,
        refetch,
    };
}
exports.useSeerRating = useSeerRating;
exports.default = useSeerRating;
